"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logUtils = {
  log: function log() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    console.log.apply(console, args); // tslint:disable-line:no-console
  },
  warn: function warn() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    console.warn.apply(console, args); // tslint:disable-line:no-console
  }
};